import type { NullableNumber } from '@shared_types/global_types'
import { isNull } from 'lodash'

const localStorageKey = 'logData'
const authenticationTtl = 1000 * 60 * 60

interface AuthData {
  timestamp: number
  login: string
  token: string
}

export function authIsExpired (timestamp: NullableNumber) {
  return isNull(timestamp) || Date.now() > +timestamp + authenticationTtl
}

export function areValidCredentials (authData?: Partial<AuthData>): authData is AuthData {
  return !!authData?.login && !!authData?.token
}

export function authIsValid (dat?: AuthData) {
  return areValidCredentials(dat) && !authIsExpired(dat.timestamp)
}

export function clearAuthData () {
  localStorage.clear()
}

export function setAuthData (dat: AuthData) {
  if (authIsValid(dat)) {
    localStorage.setItem(localStorageKey, JSON.stringify(dat))
  }
}

export function getAuthData () {
  const authData = localStorage.getItem(localStorageKey)
  return authData ? (JSON.parse(authData) as AuthData) : undefined
}

export function getToken () {
  const authData = getAuthData()
  return areValidCredentials(authData) ? authData.token : null
}

export function authHeaders (url: string): Record<string, string> {
  const token = url.startsWith('http') ? null : getToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export function isAuthenticated (user?: AuthData): user is AuthData {
  const usr = user || getAuthData()
  return !!usr && !authIsExpired(usr.timestamp)
}

export function isSupportUser (user?: AuthData) {
  const d = user || getAuthData()
  return isAuthenticated(d) && d.login === 'ycadmin'
}

export function isTechnicalUser (user?: AuthData) {
  const d = user || getAuthData()
  return isSupportUser(d) || (isAuthenticated(d) && d.login.length > 0) // === 'ycadmin'
}
